import { render, staticRenderFns } from "./BookingEmailResendModal.vue?vue&type=template&id=3c5c1314&scoped=true&"
import script from "./BookingEmailResendModal.vue?vue&type=script&lang=js&"
export * from "./BookingEmailResendModal.vue?vue&type=script&lang=js&"
import style0 from "./BookingEmailResendModal.vue?vue&type=style&index=0&id=3c5c1314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c1314",
  null
  
)

export default component.exports